import { ContainerSidebar } from 'components/container-sidebar/container-sidebar';
import { IframePreview } from '../iframe-preview/iframe-preview';
import { SimilarTemplates } from '../similar-templates/similar-templates';
import css from './main-details.module.css';
import type { TemplatePreview } from 'services/templates/types';
export type MainDetailsProps = {
  template: TemplatePreview;
  relatedTemplates: TemplatePreview[];
};
export function MainDetails({
  template,
  relatedTemplates
}: MainDetailsProps) {
  return <ContainerSidebar.Main className={css.main} data-sentry-element="unknown" data-sentry-component="MainDetails" data-sentry-source-file="main-details.tsx">
            <IframePreview template={template} data-sentry-element="IframePreview" data-sentry-source-file="main-details.tsx" />
            {relatedTemplates.length > 0 ? <SimilarTemplates templates={relatedTemplates} /> : null}
        </ContainerSidebar.Main>;
}